import React, { useState, useEffect, useCallback } from "react";

import axios from "axios";
import swal from "sweetalert";
import InputMask from "react-input-mask";

import { verify_mobile, verifyCPF } from "../utils/Utils";

import { producaov2 as api } from "../services/apis";
import { getUserNode } from "../services/auth_node";
import LabelWarning from "./LabelWarning";
import { LabelVerificator } from "./FieldVerificatorStyles";

const ProfileInfoValidator = ({ dadosIncompletos, setDadosIncompletos, setUserInfos = (dados) => console.log(dados) }) => {

  const [triedUpdateProfile, setTriedUpdateProfile] = useState(false);
  const [cpf, setCpf] = useState("");
  const [nomeCompleto, setNomeCompleto] = useState("");
  const [celular, setCelular] = useState("");
  const [dataNascimento, setDataNascimento] = useState("");
  const [cep, setCep] = useState("");
  const [validCEP, setValidCEP] = useState(false);
  const [endereco, setEndereco] = useState("");
  const [numero, setNumero] = useState("");
  const [complemento, setComplemento] = useState("");
  const [bairro, setBairro] = useState("");
  const [cidade, setCidade] = useState("");
  const [estado, setEstado] = useState("");
  const [email, setEmail] = useState("");

  useEffect(() => {
    api.get(`/perfil`).then((res) => {
      setNomeCompleto(res.data.nome);
      setEndereco(res.data.endereco);
      setCelular(res.data.celular);
      setCep(res.data.cep);
      setCpf(res.data.cpf);
      setCidade(res.data.cidade);
      setEndereco(res.data.endereco);
      setDataNascimento(res.data.data_nascimento);
      setNumero(res.data.numero);
      setComplemento(res.data.complemento);
      setBairro(res.data.bairro);
      setEstado(res.data.estado);
      setEmail(res.data.email);

      if (res.data.cep) {
        setupCep(res.data.cep)
      };

      if (
        res.data.nome &&
        res.data.endereco &&
        res.data.celular &&
        res.data.cep &&
        res.data.cpf &&
        res.data.cidade &&
        res.data.endereco &&
        res.data.data_nascimento &&
        res.data.numero &&
        res.data.bairro &&
        res.data.estado &&
        res.data.email &&
        !dadosIncompletos
      ) {
        setDadosIncompletos(false);
        setUserInfos(res.data)
      } else {
        setDadosIncompletos(true);
        setUserInfos(res.data)
      }
    });
  }, []);

  const atualizaPerfil = useCallback(
    (event) => {
      event.preventDefault();

      if (nomeCompleto.split(" ").length <= 1) {
        swal("", "Informe seu nome e sobrenome.", "error");
        return null;
      }

      if (!verifyCPF(cpf)) {
        swal("", "Infome seu CPF.", "error");
        return null;
      }

      if (celular.length < 13) {
        swal("", "Infome seu celular.", "error");
        return null;
      }

      if (!validCEP) {
        swal("", "Infome seu cep.", "error");
        return null;
      }

      if (!getUserNode().id || !getUserNode().email) {
        return null;
      }

      const atualizar_dados_params = {
        email: email,
        nome: nomeCompleto,
        data_nascimento: dataNascimento,
        cpf: cpf,
        cep: cep,
        endereco: endereco,
        numero: numero,
        bairro: bairro,
        complemento: complemento,
        cidade: cidade,
        estado: estado,
        celular: celular,
      };


      api
        .put("aluno/atualizar_dados", atualizar_dados_params,{
          headers: {
            access_token: `voitto-token ${localStorage.getItem(
              'oauth_token'
            )}`
          }
        })
        .then((v) => {
          swal("Perfil atualizado com sucesso", "", "success");
          setDadosIncompletos(false);
          setUserInfos(v.data)
        })
        .catch((v) => {
          swal(
            "Houve um erro ao atualizar seu perfil",
            "Por favor confira seus dados.",
            "error"
          );
        });
    },
    [
      validCEP,
      email,
      nomeCompleto,
      dataNascimento,
      cpf,
      cep,
      endereco,
      numero,
      bairro,
      complemento,
      cidade,
      estado,
      celular,
    ]
  );

  const renderEstados = () => {
    return (
      <select
        className="ui fluid dropdown"
        value={estado}
        onChange={(e) => setEstado(e.target.value)}
        required
        name="estado"
      >
        <option value="AC">Acre</option>
        <option value="AL">Alagoas</option>
        <option value="AP">Amapá</option>
        <option value="AM">Amazonas</option>
        <option value="BA">Bahia</option>
        <option value="CE">Ceará</option>
        <option value="DF">Distrito Federal</option>
        <option value="ES">Espírito Santo</option>
        <option value="GO">Goiás</option>
        <option value="MA">Maranhão</option>
        <option value="MT">Mato Grosso</option>
        <option value="MS">Mato Grosso do Sul</option>
        <option value="MG">Minas Gerais</option>
        <option value="PA">Pará</option>
        <option value="PB">Paraíba</option>
        <option value="PR">Paraná</option>
        <option value="PE">Pernambuco</option>
        <option value="PI">Piauí</option>
        <option value="RJ">Rio de Janeiro</option>
        <option value="RN">Rio Grande do Norte</option>
        <option value="RS">Rio Grande do Sul</option>
        <option value="RO">Rondônia</option>
        <option value="RR">Roraima</option>
        <option value="SC">Santa Catarina</option>
        <option value="SP">São Paulo</option>
        <option value="SE">Sergipe</option>
        <option value="TO">Tocantins</option>
        <option value="EX">Estrangeiro</option>
      </select>
    );
  };

  const formatarNumero = (numero) => {
    // Remove os caracteres não numéricos do número
    const numeroLimpo = numero.replace(/\D/g, "");
    if (numeroLimpo.length >= 11) {
      return `(${numeroLimpo.substr(numeroLimpo.length - 11, 2)})${numeroLimpo.substr(numeroLimpo.length - 9)}`;
    } else {
      return numero; 
    }
  };

  const formatDate = (date) => {
    const d = new Date(date);

    const formated = {
      month: `${d.getMonth() + 1}`,
      day: `${d.getDate()}`,
      year: d.getFullYear(),
    };

    if (formated.month.length < 2) {
      formated.month = `0${formated.month}`;
    }

    if (formated.day.length < 2) {
      formated.day = `0${formated.day}`;
    }

    return [formated.year, formated.month, formated.day].join("-");
  };

  const setupCep = (value) => {
    const cepNum = value.replace("-", "");
    if (cepNum.length >= 8) {
      axios
        .get(`https://viacep.com.br/ws/${cepNum}/json`)
        .then((res) => {
          const { bairro, complemento, localidade, logradouro, uf } = res.data;

          setEndereco(logradouro);
          setComplemento(complemento);
          setBairro(bairro);
          setCidade(localidade);
          setEstado(uf);
          setValidCEP(true);
        })
        .catch((err) => {
          setCep(value);
          setValidCEP(false);
        });
    }

    setCep(value);
    setValidCEP(false);
  };

  const handleDataNascimento = useCallback((e) => {
    const { value } = e.target;
    setDataNascimento(value);
  }, []);

  const validDate = () => {
    const currentYear = new Date().getFullYear();
    if (
      dataNascimento < 1900 ||
      new Date(dataNascimento).getFullYear() > currentYear
    ) {
      setDataNascimento("");
    }
  };

  return (
    dadosIncompletos && (
      <div
        style={{ minWidth: "80vw", marginBottom: "16px" }}
        id="complete-seus-dados"
        className="column dark-div circular with-border white"
      >
        <form
          onSubmit={atualizaPerfil}
          className="ui form"
          id="form-step1"
          style={{ marginTop: "35px" }}
          method="post"
        >
          <p style={{ color: "white" }}>
            <b>Complete seus dados para finalizar seu pedido:</b>
          </p>
          <div className="three fields">
            <div className="field">
              <LabelVerificator danger={triedUpdateProfile && !nomeCompleto}>
                Nome completo *
              </LabelVerificator>
              <input
                label-name="seu nome"
                className="nome my_name"
                type="text"
                name="nomecompleto"
                defaultValue={nomeCompleto}
                onChange={(e) => setNomeCompleto(e.target.value)}
                placeholder="Nome"
                minLenght={2}
                required
              />
              <LabelWarning show={triedUpdateProfile && !nomeCompleto} />
            </div>
            <div className="field">
              <LabelVerificator
                danger={triedUpdateProfile && celular.length < 2}
              >
                Whatsapp/Celular *
              </LabelVerificator>
              <InputMask
                mask="(99)99999-9999"
                minLength={13}
                maskChar={null}
                value={formatarNumero(celular)}
                name={"celular"}
                onChange={(e) => setCelular(e.target.value)}
                required
              />
              <LabelWarning show={triedUpdateProfile && celular.length < 2} />
            </div>
            <div className="field">
              <LabelVerificator danger={triedUpdateProfile && !cpf}>
                CPF *
              </LabelVerificator>
              <InputMask
                mask="999.999.999-99"
                minLength={14}
                maskChar={null}
                value={cpf}
                name={"cpf"}
                onChange={(e) => setCpf(e.target.value)}
                placeholder="Apenas os números"
                required
              />
              <LabelWarning show={triedUpdateProfile && !cpf} />
            </div>
          </div>

          <div className="three fields">
            <div className="field">
              <LabelVerificator danger={triedUpdateProfile && !dataNascimento}>
                Data de Nascimento *
              </LabelVerificator>
              <input
                label-name="sua data de nascimento"
                max={formatDate(Date.now())}
                type="date"
                name="data_nascimento"
                value={dataNascimento}
                onChange={handleDataNascimento}
                onBlur={() => validDate()}
                onKeyPress={(e) => (e.key === "Enter" ? validDate() : null)}
                required
              />
              <LabelWarning show={triedUpdateProfile && !dataNascimento} />
            </div>
            <div className="field">
              <LabelVerificator danger={triedUpdateProfile && !cep}>
                CEP *{" "}
                <a
                  target="blank"
                  href="http://www.buscacep.correios.com.br/sistemas/buscacep/"
                >
                  {" "}
                  Não sei meu CEP
                </a>
              </LabelVerificator>
              <InputMask
                mask="99999-999"
                minLength={9}
                maskChar={null}
                value={cep}
                name={"cep"}
                onChange={(e) => setupCep(e.target.value)}
                required
              />
              <LabelWarning show={triedUpdateProfile && !cep} />
            </div>
            <div className="field">
              <LabelVerificator danger={triedUpdateProfile && !endereco}>
                Logradouro *
              </LabelVerificator>
              <input
                type="text"
                name="endereco"
                value={endereco}
                onChange={(e) => setEndereco(e.target.value)}
                placeholder="Logradouro"
                required
              />
              <LabelWarning show={triedUpdateProfile && !endereco} />
            </div>
          </div>
          {cep.length > 8 && (
            <div className="dados-endereco-pos-cep block-before">
              <div className="three fields">
                <div className="field">
                  <LabelVerificator danger={triedUpdateProfile && !numero}>
                    Número *
                  </LabelVerificator>
                  <input
                    type="number"
                    name="numero"
                    value={numero}
                    onChange={(e) => setNumero(e.target.value)}
                    placeholder="0"
                    required
                  />
                  <LabelWarning show={triedUpdateProfile && !numero} />
                </div>
                <div className="field">
                  <LabelVerificator>
                    Complemento
                  </LabelVerificator>
                  <input
                    type="text"
                    name="complemento"
                    value={complemento}
                    onChange={(e) => setComplemento(e.target.value)}
                    placeholder="Bloco/Apto"
                  />
                </div>
                <div className="field">
                  <LabelVerificator danger={triedUpdateProfile && !bairro}>
                    Bairro *
                  </LabelVerificator>
                  <input
                    type="text"
                    name="bairro"
                    value={bairro}
                    onChange={(e) => setBairro(e.target.value)}
                    placeholder="Seu Bairro"
                    required
                  />
                  <LabelWarning show={triedUpdateProfile && !bairro} />
                </div>
              </div>

              <div className="three fields">
                <div className="field">
                  <LabelVerificator danger={triedUpdateProfile && !cidade}>
                    Cidade *
                  </LabelVerificator>
                  <input
                    type="text"
                    name="cidade"
                    defaultValue={cidade}
                    onChange={(e) => setCidade(e.target.value)}
                    placeholder="Sua Cidade"
                    required
                  />
                  <LabelWarning show={triedUpdateProfile && !cidade} />
                </div>
                <div className="field">
                  <LabelVerificator danger={triedUpdateProfile && !estado}>
                    Estado *
                  </LabelVerificator>
                  {renderEstados()}
                  <LabelWarning show={triedUpdateProfile && !estado} />
                </div>
              </div>
            </div>
          )}

          <p style={{ color: "white" }}>
            <b>* Campos obrigatórios</b> <br />
            <b>** Endereço completo necessário para envio de certificado e material</b>
          </p>

          <div
            style={{
              display: verify_mobile() ? null : "flex",
              justifyContent: "flex-end",
              marginLeft: verify_mobile() ? "4%" : null,
            }}
          >
            <button
              className="ui big primary button"
              onClick={() => setTriedUpdateProfile(true)}
            >
              Atualizar perfil
            </button>
          </div>
        </form>
        <div className={"ui divider"}></div>
      </div>
    )
  );
};

export default ProfileInfoValidator;
